import { AdminSettingsResponse, Setting } from '../../../../types';

export const convertToSettingsPayload = (
  data: AdminSettingsResponse,
  newData: Setting[]
) => {
  return { ...data[0], settings: newData };
};
